/*
 * Automatically generated by 'ng g ng-alain:plugin icon'
 * @see https://ng-alain.com/cli/plugin#icon
 */

import {
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  BookOutline,
  BorderLeftOutline,
  BorderRightOutline,
  CaretDownFill,
  CaretRightFill,
  CloudOutline,
  CopyrightOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DingdingOutline,
  DislikeOutline,
  DownloadOutline,
  EyeOutline,
  SearchOutline,
  FileExclamationOutline,
  FileExclamationFill,
  FileDoneOutline,
  FileTwoTone,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GithubOutline,
  GlobalOutline,
  HddOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  PayCircleOutline,
  PieChartOutline,
  PrinterOutline,
  RocketOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SoundOutline,
  StarOutline,
  SyncOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrophyOutline,
  UsbOutline,
  UserOutline,
  FolderOutline,
  FolderOpenOutline,
  FundOutline,
  DragOutline,
  EyeInvisibleOutline,
  UploadOutline,
  CloudUploadOutline,
  LeftOutline,
  RightOutline,
  ReadOutline,
  MoreOutline,
  CoffeeOutline,
  WhatsAppOutline,
  SwapLeftOutline,
  SwapOutline,
  SwapRightOutline,
  FileSearchOutline,
  FileOutline,
  FilterOutline,
  UnorderedListOutline,
  ZoomInOutline,
  ZoomOutOutline,
  RotateLeftOutline,
  RotateRightOutline,
  UserAddOutline,
  PlayCircleOutline,
  RollbackOutline,
  FileExcelOutline,
  HourglassOutline,
  ReloadOutline,
  MenuOutline,
  SendOutline,
  PlusSquareOutline,
  MinusSquareOutline,
  FilePdfOutline,
  HistoryOutline,
  NotificationOutline,
  AlertOutline,
  FlagOutline,
  VerticalLeftOutline,
  VerticalRightOutline,
  CloudDownloadOutline,
  ExportOutline,
  ContainerOutline,
  PlusCircleFill,
  PlusCircleOutline,
  BarsOutline,
  PlusCircleTwoTone,
  ArrowLeftOutline,
  CheckCircleTwoTone,
  CheckCircleFill,
  CloseCircleTwoTone,
  CloseOutline,
  MinusOutline,
  QrcodeOutline,
  EllipsisOutline,
  PushpinOutline,
  PushpinFill,
  LoginOutline,
  WarningFill,
  MobileOutline,
  AndroidFill,
  AppstoreAddOutline,
  ExperimentTwoTone,
  FormOutline,
  ArrowRightOutline,
  WarningOutline,
  SmallDashOutline,
  QuestionCircleOutline,
  MinusCircleOutline,
  TableOutline,
  InsertRowAboveOutline,
  SaveOutline,
  SafetyCertificateOutline,
  SafetyCertificateFill,
  AudioOutline,
  AudioFill,
  ColumnWidthOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  BookOutline,
  BorderLeftOutline,
  BorderRightOutline,
  CaretDownFill,
  CaretRightFill,
  CloudOutline,
  CopyrightOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DingdingOutline,
  DislikeOutline,
  DownloadOutline,
  EyeOutline,
  FileExclamationOutline,
  FileExclamationFill,
  FileDoneOutline,
  FileTwoTone,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GithubOutline,
  GlobalOutline,
  HddOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  PayCircleOutline,
  PieChartOutline,
  PrinterOutline,
  RocketOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SoundOutline,
  StarOutline,
  SyncOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrophyOutline,
  UsbOutline,
  UserOutline,
  FolderOutline,
  FolderOpenOutline,
  FundOutline,
  DragOutline,
  EyeInvisibleOutline,
  UploadOutline,
  CloudUploadOutline,
  LeftOutline,
  RightOutline,
  ReadOutline,
  MoreOutline,
  CoffeeOutline,
  WhatsAppOutline,
  SwapLeftOutline,
  SwapOutline,
  SwapRightOutline,
  FileSearchOutline,
  FilterOutline,
  UnorderedListOutline,
  ZoomInOutline,
  ZoomOutOutline,
  RotateLeftOutline,
  RotateRightOutline,
  FileOutline,
  UserAddOutline,
  PlayCircleOutline,
  RollbackOutline,
  FileExcelOutline,
  HourglassOutline,
  ReloadOutline,
  MenuOutline,
  SendOutline,
  PlusSquareOutline,
  MinusSquareOutline,
  FilePdfOutline,
  HistoryOutline,
  NotificationOutline,
  AlertOutline,
  FlagOutline,
  VerticalLeftOutline,
  VerticalRightOutline,
  CloudDownloadOutline,
  ExportOutline,
  ContainerOutline,
  PlusCircleFill,
  PlusCircleOutline,
  BarsOutline,
  PlusCircleTwoTone,
  ArrowLeftOutline,
  CheckCircleTwoTone,
  CheckCircleFill,
  CloseCircleTwoTone,
  CloseOutline,
  MinusOutline,
  QrcodeOutline,
  EllipsisOutline,
  PushpinOutline,
  PushpinFill,
  LoginOutline,
  WarningFill,
  MobileOutline,
  AndroidFill,
  AppstoreAddOutline,
  ExperimentTwoTone,
  FormOutline,
  ArrowRightOutline,
  WarningOutline,
  SmallDashOutline,
  QuestionCircleOutline,
  SearchOutline,
  MinusCircleOutline,
  TableOutline,
  InsertRowAboveOutline,
  SaveOutline,
  SafetyCertificateOutline,
  SafetyCertificateFill,
  AudioOutline,
  AudioFill,
  ColumnWidthOutline
];
